const GithubActivityContainer: React.FC = () => {
    return (
        <div>
            <h3>My GitHub & other code activities</h3>
        </div>
    );
}

export default GithubActivityContainer;